"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.search.placeholder': 'Szukaj sesji onboardingu...',
};
